import React, { useState } from 'react';
import './ProductsSection.css';
import {Link} from 'react-router-dom';

const allCards = [
  [
    { logo: '/technology.webp', title: 'TECHNOLOGY', description: 'Alongside software, technology is perhaps the worlds fastest-changing industry. Nowadays, the majority of tech companies strive for a website that continuously generates leads.' },
    { logo: '/finance.webp', title: 'FINANCE', description: 'Fintech is an industry like no other. Top-level security is crucial when large sums of money are processed and sensitive data is involved.' },
    { logo: '/manufacturing.webp', title: 'MANUFACTURING', description: 'Before the internet became a part of our daily lives, industrial and manufacturing enterprises focused their marketing efforts mostly on traditional sales techniques such as trade exhibitions, conferences, and ads in industry magazines.' },
  ],
  [
    { logo: '/real-estate.webp', title: 'REAL ESTATE', description: 'Choosing a house to buy is a challenging decision. Since buying or renting real estate requires a large sum of money, people are likely to do a lot of research to get an idea about the available properties and realtors that match their needs..' },
    { logo: '/retail.webp', title: 'RETAIL', description: 'SThe retail industry has undergone a paradigm shift over the last few years. Changes in consumer behavior, lower income rates, and tech-savvy consumers have made it impossible for shops to operate without technology.' },
    { logo: '/security.webp', title: 'SECURITY', description: 'For the past several years, security has dominated headlines and significantly impacted the privacy and confidentiality of millions of users. Security plays a critical role in todays society, where safe and trustworthy software is necessary to protect our personal information and important business data.' },
  ],
  [
    { logo: '/sports.webp', title: 'SPORTS', description: 'With sports being deeply embedded into the culture of many countries, the sports industry is expected to scale at a swift pace in the coming years.' },
    { logo: '/transportation.webp', title: 'TRANSPORTATION', description: 'The transportation industry meets the need for moving freight, passengers, information, and even food as efficiently as possible. Technology and communication are crucial for transportation as customers expect features and functionality that include trackers, emergency alerts, planners, timetables, and maps, amongst others.' },
    { logo: '/travel.webp', title: 'TRAVEL', description: 'Is your job to get people to their dream destinations? Well, ours is to help you do that but with less effort. We know exactly what features the most successful travel operators rely on and what functionalities users look for when searching for their next holiday spot.' },
  ],
];

const ProductsSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="products-section" id = "industries">
      <div className="container">
      <div className="products-header">
        <div className="products-heading">
          CRAFTING HIGH-QUALITY PRODUCTS IN <span>MANY INDUSTRIES</span>
        </div>
        <div className="products-paragraph">
          Our agile engineering practices and best-in-class Europe-based developers bring software craftsmanship, high-quality, and consistency to your projects in industries galore.
        </div>
      </div>

      <div className="carousel-wrapper">
        <div
          className="carousel-track"
          style={{
            transform: `translateX(-${activeIndex * 100}%)`,
          }}
        >
          {allCards.map((group, groupIdx) => (
            <div className="carousel-slide" key={groupIdx}>
              {group.map((card, index) => (
                <div className="product-card" key={index}>
                  <img src={card.logo} alt="Logo" className="card-logo" />
                  <h4>{card.title}</h4>
                  <p>{card.description}</p>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="carousel-dots">
        {allCards.map((_, idx) => (
          <div
            key={idx}
            className={`dot ${activeIndex === idx ? 'active' : ''}`}
            onClick={() => setActiveIndex(idx)}
          ></div>
        ))}
      </div>

      <div className="center-button">
        <Link to="/industries">
  <button>OUR CROSS-INDUSTRY APPROACH</button>
</Link>
      </div>
      </div>
    </section>
  );
};

export default ProductsSection;
